export * from './agris-cotiz-detalle-pnjde-dialog.component';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-cotizacion-detalle-page/agris-cotiz-detalle-pnjde-dialog/index.ts